import { gql } from '@apollo/client';

const INBOXES_QUERY = gql`
  query inboxes($filter: InboxFilterInput, $limit: Int) {
    inboxes(filter: $filter, limit: $limit) {
      isSuccess
      message
      reports {
        id
        reportId
        type
        start
        stop
        statusReport
        lastStatusReportAt
        study {
          id
          deviceId
          friendlyId
          externalSource {
            provider
            externalId
          }
          start
          status
          stop
          reportDueDate
          timezone
          studyTimeOffset
          isNonPhi
          facility {
            id
            name
            contact {
              country
            }
            arrears
            timezone
          }
          info {
            interprettingPhysician {
              id
              firstName
              lastName
            }
            patient {
              firstName
              lastName
              patientId
            }
          }
          studyType
          timezone
          isBiofluxDirect
          device {
            model
          }
        }
        event {
          id
          friendlyId
          hasClinicData
          comments
        }
        hasSignature
        technicianComments
        findings
        reportFindings
        physicianInterpretation
        inbox {
          date
          priority
          isReviewed
          isRead
        }
        isArtifactReport
        isNewFormat
        formatVersion
        aiFormatVersion
        profile
        status
        lastModified
        isRenderingBackground
      }
      recentUnreadCount
    }
  }
`;

export default INBOXES_QUERY;
